export default __webpack_public_path__ + "static/media/ShjMunUniPortal-LogoBGVer.2db6f17b.svg";